import React from "react";
import TlkTable from "../../tlelrik/table/tlkTable";
import services from "../../../services";
import queryString from "query-string";
import { filter } from "@progress/kendo-data-query/dist/npm/transducers";

const groupfield = [
    //{ field: "Nº Parcela IVDP" },
    //{ field: "Entreposto" },
    // { field: 'Concelho' },
    // { field: 'Freguesia' },
];

const columnKeyMap = {
    // designação: "Instalação vínica",
    // nome: "Entidade",
    // nomeEntreposto: "Entreposto",
    // tipo_de_Instalação: "Tipo de instalação",
    // idInstalacaoVinica: "Número de instalação vínica",
    // estado: "Estado",
    // saldoTotal: "Saldo Total",
    // saldoGranel: "Não certificado",
    // saldoApto: "Indisponível granel",
    // saldoEngarrafado: "Indisponível engarrafado",
    // comercializado: "Comercializado", // TODO: Ask @Dart about the key to be used here
    localArmazenagem: "Local de Armazenagem",
    instalacaoVinica: "Instalação Vínica",
    //nomeEntidade: "Entidade",
    //codEntrFiscal: "Codigo Entreposto fiscal",
    saldoGranel: "Granel Não Certificado",
    saldoGranelApto: "Granel Apto",
    saldoIndispGranel: "Indisp a Granel",
    saldoIndispEngarrafado: "Indisp Engarrafado",
    saldoProdutoAcabado: "Produto Acabado",
    estado: "Estado",
    codIVV: "Cod IVV"
};

const actionbuttons = { CommonRedirection: "Detalhes da Conta" };

const filterValue = {
    Concelho: null,
    DataCriadoEnd: null,
    DataCriadoStart: null,
    DataModificadoEnd: null,
    DataModificadoStart: null,
    Designacao: null,
    Distrito: null,
    Estado: null,
    Fregusia: null,
    Geocod: null,
    NomeEntreposto: null,
    NumInstalacao: null,
    TipoInstalacao: null,
    nome: null,
    numero: null,
    entityId: null,
};

class InstallationTab extends React.Component {
    constructor() {
        super();

        this.state = {
            loaded: false,
            data: [],
            totalCount: 0,
            columnList: [],
            filters: {
                Filters: filterValue,
                FiltersIn: null,
                FiltersLike: null,
                SortBy: "",
                IsSortTypeDESC: true,
                IsPagination: false,
                Page: 2,
                PageSize: 2,
            },
        };
    }

    componentDidMount() {
        (async () => {
            console.log("did mount 666");
            const queryParams = queryString.parse(this.props.location.search);
            const filters = {
                ...this.state.filters,
                Filters: {
                    ...this.state.filters.Filters,
                    NumInstalacao: queryParams.nif,
                    entityId: queryParams.entityId
                },
            };
            this.setState({
                nif: queryParams.nif,
            });
            const response = await services.apiCall.requestApi(
                "InstalacaoVinica/GetInstalacoesVinicas",
                filters,
                "post"
            );
            // const columnList = Object.keys(columnKeyMap).map((key) => ({
            //     field: columnKeyMap[key],
            //     columnMenuType: "checkbox",
            // }));

            var columnList = [];

            Object.keys(columnKeyMap).forEach(e => {
                if(e == "saldoGranel" || e == "saldoGranelApto" || e == "saldoIndispGranel" || e == "saldoIndispEngarrafado" || e == "saldoProdutoAcabado"){
                    columnList.push({field: columnKeyMap[e], columnMenuType: "number"});
                }
                else{
                    columnList.push({field: columnKeyMap[e], columnMenuType: "checkbox"});
                }
            });

            if (response) {
                // const data = response.map((entity) => ({
                //   ...Object.keys(columnKeyMap).reduce((acc, key) => {
                //     acc[columnKeyMap[key]] = entity[key]
                //     return acc;
                //   }, {}),
                //   selected: false,
                // }));
                const data = response.map((entity, index) => ({
                    ...entity,
                    ...Object.keys(columnKeyMap).map((key) => {
                        if (key === "saldoTotal") {
                            let saldoTotal = Number(
                                Number(
                                    entity["saldoGranel"]
                                        ? entity["saldoGranel"]
                                        : ""
                                ) +
                                    Number(
                                        entity["saldoApto"]
                                            ? entity["saldoApto"]
                                            : ""
                                    ) +
                                    Number(
                                        entity["saldoEngarrafado"]
                                            ? entity["saldoEngarrafado"]
                                            : ""
                                    ) +
                                    Number(
                                        entity["comercializado"]
                                            ? entity["comercializado"]
                                            : ""
                                    )
                            );
                            entity[columnKeyMap[key]] = services.money.format(
                                saldoTotal.toString()
                            );
                        } else if (
                            key === "saldoGranel" ||
                            key === "saldoGranelApto" ||
                            key === "saldoIndispGranel" ||
                            key === "saldoIndispEngarrafado" ||
                            key === "saldoProdutoAcabado"
                        ) {
                            entity[columnKeyMap[key]] = services.money.format(entity[key]) || "0";
                        } else {
                            entity[columnKeyMap[key]] = entity[key] || "NA";
                        }
                    }),
                    selected: false,
                }));
                this.setState(() => ({
                    data,
                    columnList,
                    totalCount: window.localStorage.getItem("table_total"),
                    loaded: true,
                }));
            } else {
                this.setState(() => ({
                    data: response,
                    totalCount: 0,
                    columnList,
                    loaded: false,
                }));
            }
        })();
    }

    selectionChange(selection) {
        const data = [...this.state.data].map((item) => {
            if (
                selection.dataItem.codInstalacaoVinica ===
                item.codInstalacaoVinica
            ) {
                // TODO: Ask @Dart for the unique key to use here
                return { ...item, selected: true };
            } else {
                return { ...item, selected: false };
            }
        });
        this.setState({ data }, async () => {
            const queryParams = queryString.stringify({
                ...queryString.parse(this.props.location.search),
                installationId: 0,
            });
            this.props.history.push(
                `/conta_corrente/accounts_view?${queryParams}`
            );
        });
    }

    ActionPerform = async (action, row) => {
        // TODO: Rohit — Export data from grid
        if (action === "Detalhes da Conta") {
            // const data = [...this.state.data].map((item) => {
            //   if (row.codInstalacaoVinica === item.codInstalacaoVinica) { // TODO: Ask @Dart for the unique key to use here
            //     return { ...item, selected: true };
            //   } else {
            //     return { ...item, selected: false };
            //   }
            // });
            // this.setState({ data }, async () => {
            console.log("the row 8899 is ", row);
            const queryParams = queryString.stringify({
                entityId: row.detalheURLCodEntidade,
                IDInstalacaoVinica: row.detalheURLIDInstalacao,
                nif: this.state.nif,
            });
            this.props.history.push(
                `/conta_corrente/tabs_view/account?${queryParams}`
            );
            // });
        }
    };

    render() {
        return (
            <>
                {
                    <>
                        <span>
                            A pesquisa retornou {this.state.totalCount} registos
                        </span>
                        <TlkTable
                            date={new Date()}
                            list={this.state.data}
                            modulename={"Conta Corrente"}
                            // notAction={ false }
                            // notGroup={true}
                            groupfield={groupfield}
                            actionbuttons={actionbuttons}
                            columnlist={this.state.columnList}
                            ActionPerform={(action, id) =>
                                this.ActionPerform(action, id)
                            }
                            // selection={ true }
                            // selectionChange={ (e) => this.selectionChange(e) }
                            toolbarHTML="Contas Corrente ativas da entidade - Instalação"
                        />
                    </>
                }
            </>
        );
    }
}

export default InstallationTab;
